/**
 * Uses Google's bootstrap loader so importLibrary() is available (required for
 * PlaceAutocompleteElement; avoids deprecated Autocomplete). Resolves with
 * a merged maps+marker lib so VueMap gets Map, Marker, Circle.
 */
function ensureBootstrap(key) {
	if (window._googleMapsBootstrapPromise) {
		return window._googleMapsBootstrapPromise;
	}
	var config = { key: key, v: "weekly" };
	// Google's bootstrap loader - sets up google.maps.importLibrary
	// https://developers.google.com/maps/documentation/javascript/load-maps-js-api
	var bootstrap = "(function(g){var h,a,k,p='The Google Maps JavaScript API',c='google',l='importLibrary',q='__ib__',m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=function(){return h||(h=new Promise(function(res,rej){a=m.createElement('script');e.set('libraries',Array.from(r).join(','));for(k in g)e.set(k.replace(/[A-Z]/g,function(x){return'_'+x[0].toLowerCase()}),g[k]);e.set('callback',c+'.maps.'+q);a.src='https://maps.'+c+'apis.com/maps/api/js?'+e;d[q]=res;a.onerror=function(){h=rej(Error(p+' could not load.'));};var nonceEl=m.querySelector('script[nonce]');if(nonceEl&&nonceEl.nonce)a.nonce=nonceEl.nonce;m.head.appendChild(a);}));};if(d[l]){console.warn(p+' only loads once. Ignoring:',g);}else{d[l]=function(f){var n=Array.prototype.slice.call(arguments,1);r.add(f);return u().then(function(){return d[l].apply(d,[f].concat(n));});};}})(CONFIG);";
	var scriptContent = bootstrap.replace("CONFIG", JSON.stringify(config));
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.textContent = scriptContent;
	document.head.appendChild(script);
	window._googleMapsBootstrapPromise = Promise.resolve();
	return window._googleMapsBootstrapPromise;
}

export default {
	methods: {
		loadGoogleMaps(key) {
			if (window._googleMapsMergedLib) {
				return Promise.resolve(window._googleMapsMergedLib);
			}
			if (window._googleMapsLoadingPromise) {
				return window._googleMapsLoadingPromise;
			}
			window._googleMapsLoadingPromise = ensureBootstrap(key).then(function () {
				var importLibrary = window.google && window.google.maps && window.google.maps.importLibrary;
				if (!importLibrary) {
					return Promise.reject(new Error("Google Maps importLibrary not available."));
				}
				return Promise.all([
					importLibrary("maps"),
					importLibrary("marker")
				]).then(function (libs) {
					var mapsLib = libs[0];
					var markerLib = libs[1];
					var Marker = (markerLib && (markerLib.Marker || markerLib.AdvancedMarkerElement)) || null;
					var merged = Object.assign({}, mapsLib, Marker ? { Marker: Marker } : {});
					window._googleMapsMergedLib = merged;
					return merged;
				});
			});
			return window._googleMapsLoadingPromise;
		},
		/** Use for Place Autocomplete (new API). Ensures bootstrap is ready then loads places library. */
		loadGooglePlaces(key) {
			return this.loadGoogleMaps(key).then(function () {
				var importLibrary = window.google && window.google.maps && window.google.maps.importLibrary;
				if (!importLibrary) return Promise.reject(new Error("importLibrary not available"));
				return importLibrary("places");
			});
		},
		/** Geocoder: get address_components from an address string (used because new Place API often doesn't expose addressComponents when we need it). */
		loadGoogleGeocoding() {
			return this.loadGoogleMaps(this.$store.GoogleEmbedAPIkey).then(function () {
				var importLibrary = window.google && window.google.maps && window.google.maps.importLibrary;
				if (!importLibrary) return Promise.reject(new Error("importLibrary not available"));
				return importLibrary("geocoding");
			});
		}
	}
};
